module.exports = __webpack_public_path__ + "static/media/wellbeing@3x.e672a487.png";